import React from "react";
import PropTypes from "prop-types";
import { createGlobalStyle, ThemeProvider } from "styled-components";

const GlobalStyle = createGlobalStyle`
body{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Roboto", sans-serif;
}
`;

const ThemeProps = {
    colors: {
        background: "#202020",
        primary: "#151515",
        secondary: "#eb2328",
        third: "#ffffff",
    },
    fonts: ["sans-serif", "Roboto"],
    fontSizes: {
        small: "1.0rem",
        medium: "2.0rem",
        large: "3.0rem",
    },
};

export default function Theme({ children }) {
    return (
        <ThemeProvider theme={ThemeProps}>
            {children}
            <GlobalStyle />
        </ThemeProvider>
    );
}

Theme.propTypes = {
    children: PropTypes.object,
};
